import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchCurrentTenant(): Promise<Components.Schemas.TenantDto | null> {
  const result = await Api.Routes.Tenant.getTenant();
  return result.data;
}

export async function fetchCurrentTenantOwnersAndAdmins(): Promise<Components.Schemas.UserDataDto[]> {
  const result = await Api.Routes.Tenant.getTenantOwnersAndAdmins();
  return result.data;
}

export async function updateCurrentTenant(dto: Components.Schemas.UpdateTenantDto): Promise<void> {
  await Api.Routes.Tenant.updateTenant(null, dto);
}

export async function uploadTenantLogo(file: File): Promise<void> {
  await Api.Routes.Tenant.uploadLogo(null, { file });
}

export async function removeTenantLogo(): Promise<void> {
  await Api.Routes.Tenant.removeLogo();
}

export async function updateTenantSchoolLevels(schoolLevels: [number, ...number[]]): Promise<void> {
  await Api.Routes.Tenant.updateSchoolLevels(null, { schoolLevels });
}

export async function completeTenantAdministrationSetup(): Promise<void> {
  await Api.Routes.Tenant.completeAdministrationSetup();
}

export async function markTenantCompetenceSetupChoiceDialogSeen(): Promise<Components.Schemas.TenantDto> {
  const result = await Api.Routes.Tenant.markCompetenceSetupChoiceDialogSeen();
  return result.data;
}
